<template>
  <div v-show="isRideTypeSelectionHaveOptions">
    <slot>
      <CustomBtnToggle
        :value="rideType"
        data-test="rideTypeToggle"
        :items="rideTypeItems"
        @change="setRideType"
      />
    </slot>
  </div>
</template>
<script lang="ts">
export default {
  name: 'SRideTypeSelection',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import RideTypeEnum from '@slg/web-customer-shared/src/enum/RideTypeEnum';
import CustomBtnToggle from '@slg/web-customer-shared/src/components/common/CustomBtnToggle.vue';
import { useI18n } from '../../../composables';

const props = defineProps({
  rideType: {
    type: String,
    default: null,
  },
  availableShuttleType: {
    type: String,
    default: null,
  },
  animalsTransportation: {
    type: Boolean,
    default: false,
  },
  appConfig: {
    type: Object,
    default: () => {},
  },
});

const emit = defineEmits(['setRideType']);
const { t } = useI18n();

const isRideTypeSelectionHaveOptions = computed(() => {
  if (props.appConfig.isNightCardsSupport) {
    return false;
  } else if (props.availableShuttleType === RideTypeEnum.BOTH) {
    return true;
  } else {
    return false;
  }
});

const rideTypeItems = computed(() => {
  if (props.appConfig.isNightCardsSupport) {
    return [{
      text: t(`bookingForm.${RideTypeEnum.SHARED}`),
      value: RideTypeEnum.SHARED,
      disabled: props.animalsTransportation,
      hints: ['bookingForm.hints.animalsAreNotAllowed', 'bookingForm.hints.turnOffTheAnimalCarriage'],
    },];
  }
  else if (props.availableShuttleType === RideTypeEnum.BOTH) {
    return [
      {
        text: t(`bookingForm.${RideTypeEnum.PRIVATE}`),
        value: RideTypeEnum.PRIVATE,
      },
      {
        text: t(`bookingForm.${RideTypeEnum.SHARED}`),
        value: RideTypeEnum.SHARED,
        disabled: props.animalsTransportation,
        hints: ['bookingForm.hints.animalsAreNotAllowed', 'bookingForm.hints.turnOffTheAnimalCarriage'],
      },
    ];
  }
  return [];
});

function setRideType(newType) {
  emit('setRideType', newType);
}
</script>

<style scoped lang="scss">
</style>
